<template>
	<div class="container">
		<el-menu class="custom-menu" :default-active="activeMenu" active-text-color="#ffd04b" background-color="#545c64"
			text-color="#fff" router>
			<el-menu-item index="/dashboard" class="custom-menu-item">
				<el-icon>
					<House />
				</el-icon>
				<span>工作台</span>
			</el-menu-item>

			<el-sub-menu index="user" class="custom-submenu">
				<template #title>
					<el-icon>
						<User />
					</el-icon>
					<span>用户管理</span>
				</template>
				<el-menu-item index="/user/info" class="custom-subitem">用户信息</el-menu-item>
				<el-menu-item index="/user/upload" class="custom-subitem">用户上传</el-menu-item>
				<el-menu-item index="/user/request" class="custom-subitem">用户求购</el-menu-item>
				<el-menu-item index="/user/favorite" class="custom-subitem">用户收藏</el-menu-item>
				<el-menu-item index="/user/history" class="custom-subitem">历史记录</el-menu-item>
			</el-sub-menu>

			<el-menu-item index="/machine" class="custom-menu-item">
				<el-icon>
					<Tools />
				</el-icon>
				<span>设备管理</span>
			</el-menu-item>

			<el-menu-item index="/category" class="custom-menu-item">
				<el-icon>
					<Menu />
				</el-icon>
				<span>分类管理</span>
			</el-menu-item>

			<el-menu-item index="/location" class="custom-menu-item">
				<el-icon>
					<Location />
				</el-icon>
				<span>地区管理</span>
			</el-menu-item>

			<el-menu-item index="/employee" class="custom-menu-item">
				<el-icon>
					<User />
				</el-icon>
				<span>员工管理</span>
			</el-menu-item>

			<el-menu-item index="/swiper" class="custom-menu-item">
				<el-icon>
					<Picture />
				</el-icon>
				<span>轮播图管理</span>
			</el-menu-item>
		</el-menu>
	</div>
</template>


<script>
	export default {
		name: 'SidebarMenu',
		props: {
			activeMenu: {
				type: String,
				required: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		height: 100vh;
		display: flex;
	}

	.custom-menu {
		width: 180px;
		border: none;
		padding: 20px 0;
		background-color: #545c64;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	// 一级菜单样式
	.custom-menu-item {
		margin: 0 16px;
		padding: 8px 12px !important;
		border-radius: 12px;
		transition: background-color 0.25s, color 0.25s;

		&:hover {
			background-color: #e0e0e0 !important;
			color: #000 !important;
		}

		&.is-active {
			background-color: #fffcf3 !important;
			color: #000 !important;
			font-weight: 600;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
		}
	}

	// 子菜单标题
	.custom-submenu>>>.el-sub-menu__title {
		margin: 0 16px;
		padding: 8px 12px !important;
		border-radius: 12px;
		transition: background-color 0.25s, color 0.25s;

		&:hover {
			background-color: #e0e0e0 !important;
			color: #000 !important;
		}
	}

	// 子菜单项（展开后的）
	.custom-subitem {
		margin: 6px 16px !important;
		border-radius: 10px;
		padding-left: 20px !important;

		&:hover {
			background-color: #f5f5f5 !important;
			color: #000 !important;
		}

		&.is-active {
			background-color: #fffcf3 !important;
			color: #000 !important;
			font-weight: 600;
		}
	}
</style>